<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">내 PC 취약점 검사</h1>
      <p class="page-tit" aria-hidden="true">내 PC 취약점 검사</p>
    </div>
    <h2 class="section-title">점검 도구</h2>

    <!--점검 파일 입력-->
    <div class="notice-box--warning">
      <strong>검사 진행 전 반드시 확인해 주세요</strong>

      <div class="notice-em tb-m-only" role="status" aria-live="polite">
        내 PC 취약점 검사는 모바일에서는 지원되지 않으며, PC에서 이용
        가능합니다.
      </div>

      <div class="notice-em pc-only" role="status" aria-live="polite">
        <ul class="notice-list">
          <li>
            1. 한국인터넷진흥원(KISA)에 신고된 취약 파일의 해시 목록과 귀하의
            PC에 저장된 파일 해시를 대조하여 동일 파일의 존재 여부를 검사합니다.
          </li>
          <li>
            2. 본 절차의 모든 처리는 사용자의 브라우저(클라이언트) 내에서만
            수행되며 원본 파일 또는 파일 내용은 시스템 외부로 전송되거나
            저장되지 않습니다.
          </li>
          <li>
            3. 검사 진행 중 페이지 이동, 브라우저 종료 또는 새로고침 시 현재
            진행 중인 검사는 중단되며, 검사 대상 데이터는 초기화됩니다.
          </li>
          <li>
            4. 업로드한 폴더 내 파일 개수가 많을수록 검사 소요 시간은 증가할 수
            있습니다.
          </li>
          <li>
            5. 대용량 파일은 브라우저 환경에서 정상적인 해시 생성이 어려워,
            안정적인 검사 제공을 위해 검사 대상에서 제외됩니다.
          </li>
          <li>
            6. 검사 결과는 검사 완료 후 목록 화면에서 확인하실 수 있습니다.
          </li>
        </ul>
      </div>
    </div>
    <!--     
    <div class="notice-box--warning">
      <strong>검사 진행 전 반드시 확인해 주세요</strong>
      <div class="notice-em tb-m-only" role="status" aria-live="polite">
        내 PC 취약점 검사는 모바일에서는 지원되지 않으며, PC에서 이용
        가능합니다.
      </div>
      <div class="notice-em pc-only" role="status" aria-live="polite">
        1. 한국인터넷진흥원(KISA)에 신고된 취약 파일의 해시 목록과 귀하의 PC에
        저장된 파일 해시를 대조하여 동일 파일의 존재 여부를 검사합니다.
      </div>
      <div class="notice-em pc-only" role="status" aria-live="polite">
        2. 본 절차의 모든 처리는 사용자의 브라우저(클라이언트) 내에서만 수행되며
        원본 파일 또는 파일 내용은 시스템 외부로 전송되거나 저장되지 않습니다.
      </div>
      <div class="notice-em pc-only" role="status" aria-live="polite">
        3. 검사 진행 중 페이지 이동, 브라우저 종료 또는 새로고침 시 현재 진행
        중인 검사는 중단되며, 검사 대상 데이터는 초기화됩니다.
      </div>
      <div class="notice-em pc-only" role="status" aria-live="polite">
        4. 업로드한 폴더 내 파일 개수가 많을수록 검사 소요 시간은 증가할 수
        있습니다.
      </div>
      <div class="notice-em pc-only" role="status" aria-live="polite">
        5. 대용량 파일은 브라우저 환경에서 정상적인 해시 생성이 어려워, 안정적인
        검사 제공을 위해 검사 대상에서 제외됩니다.
      </div>
      <div class="notice-em pc-only" role="status" aria-live="polite">
        6. 검사 결과는 검사 완료 후 목록 화면에서 확인하실 수 있습니다.
      </div>
    </div> -->

    <!-- 스캔 로딩 박스 (STEP 전용) -->
    <div class="scan-loading-box pc-only">
      <div class="scan-notice-wrapper">
        <div class="scan-notice">
          <template v-if="scanStatus !== 'wait' && scanStatus !== 'completed'">
            <p>
              검사가 진행중이며, 완료까지 다소 시간이 소요될수 있습니다. 잠시만
              기다려 주세요...
            </p>
            <span class="scan-time">검사 시간: {{ scanTime }}</span>
            <button
              type="button"
              class="scan-btn cancel"
              v-on:click="cancelScan"
            >
              점검 취소
            </button>
          </template>
          <template v-if="scanStatus === 'completed'">
            <p>검사가 완료되었습니다.</p>
            <span class="scan-time">검사시간: {{ scanTime }}</span>
            <button
              type="button"
              class="scan-btn restart"
              v-on:click="restartScan()"
              v-if="
                scanStatus == 'completed' || scanStatus === 'inspectCancelled'
              "
            >
              새 검사 시작
            </button>
          </template>
        </div>
      </div>

      <div class="scan-loading-box__inner">
        <div class="step" :class="getStepStatus('folder')">
          <div class="step__circle"></div>
          <div
            class="step__card drop-zone"
            @dragenter.prevent
            @dragover.prevent
            @drop.prevent="handleDrop"
          >
            <em>1단계</em>
            <strong>폴더 등록</strong>
            <p class="step__desc" v-if="scanStatus === 'wait'">
              드래그 앤 드랍으로 폴더를 업로드 하세요.
            </p>
            <p class="step__desc" v-else>폴더명 : {{ folderName }}</p>

            <input
              type="text"
              class="drop-input"
              placeholder="폴더를 드래그 앤 드롭하여 등록해주세요."
              readonly
              v-model="folderName"
              v-if="scanStatus !== 'completed'"
            />
          </div>
        </div>

        <div class="step" :class="getStepStatus('scanning')">
          <div class="step__circle"></div>
          <div class="step__card">
            <em>2단계</em>
            <strong>폴더 스캐닝</strong>
            <span v-if="scanStatus !== 'wait' && scanStatus !== 'completed'">{{
              scanningFileName
            }}</span>
          </div>
        </div>

        <div class="step" :class="getStepStatus('checking')">
          <div class="step__circle"></div>
          <div class="step__card">
            <em>3단계</em>
            <strong>파일 검사</strong>
            <span v-if="scanStatus !== 'wait' && scanStatus !== 'completed'">{{
              currentFileName
            }}</span>
          </div>
        </div>

        <div class="step" :class="getStepStatus('saving')">
          <div class="step__circle"></div>
          <div class="step__card">
            <em>4단계</em>
            <strong>결과 생성 및 저장</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="list-table__top type-row--mobile">
      <h2 class="section-title">점검 결과</h2>
      <span class="list-table__total">총 {{ pagingInfo.total }}건</span>
    </div>
    <table class="list-table type-block--mobile">
      <caption>
        점검결과 리스트 입니다.
      </caption>
      <thead>
        <tr>
          <th scope="col">순번</th>
          <th scope="col">점검 일시</th>
          <th scope="col">진행 상태</th>
          <th scope="col">취약점 발견 건수</th>
          <th scope="col">발견 건수</th>
          <th scope="col">SBDM 버전</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="item._id"
          @click="goToDetail(item)"
          class="clickable-row"
        >
          <td class="no-field">
            {{ convertId(index) }}
          </td>
          <td class="info-field">
            <span class="th--only-mobile">점검일시</span>
            {{ convertDateFormat(item.inspectStartDate) }}
          </td>
          <td class="info-field">
            <span class="th--only-mobile">진행 상태</span>
            <div class="ellipsis">{{ convertStatus(item) }}</div>
          </td>
          <td class="info-field">
            <span class="th--only-mobile">취약점 발견 건수</span
            >{{ item?.inspectionResults?.length || 0 }}
          </td>
          <td class="info-field">
            <span class="th--only-mobile">취약점 발견 건수</span
            >{{ item?.detectedCount || 0 }}
          </td>
          <td class="info-field">
            <span class="th--only-mobile">SBDM 버전</span>{{ item.vpmdVersion }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="items == null || items.length == 0" class="no-data">
      {{
        isLoading
          ? "데이터 조회중입니다. 잠시만 기다려주십시오."
          : "검색 결과 없음..."
      }}
    </div>
    <Paging
      v-model="pagingInfo.currentPage"
      :totalItems="pagingInfo.total"
      :visibleCount="pagingInfo.limitNum"
      @update:modelValue="getPage"
    />
  </div>
</template>

<script>
import dc from "@/component/utils/DataChk.js";
import dt from "@/component/utils/DateTime.js";
import paging from "@/component/paging/Paging.js";
import tb from "@/component/utils/Table.js";
import {
  computed,
  inject,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  toRaw,
} from "vue";
import { onBeforeRouteLeave, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  // props
  props: {
    msg: String,
  },
  //setup()
  setup() {
    const axios = inject("axios");
    const router = useRouter();
    const store = useStore();

    //data 정의
    const pagingInfo = reactive({
      currentPage: 1, // 현재페이지
      prePage: 1, // 이전페이지
      perPage: 10, // n개씩보기
      limitNum: 5, // 화면에 표시할 페이지 수
      type: 1, // 1 = 처음부터 조회, 2 = preKey/nextKey 사용, 3 = n개씩보기 변경
      total: -1,
      pageNum: 0,
      doubleTab: false,
    });

    const searchInfo = ref({
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
    });
    const savedSearchInfo = ref({
      // getList(1) 후 저장된 검색 조건
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
    });
    const progress = ref(0);
    const vulnHashes = ref({}); // 취약점 해시
    const vpmdVer = ref("");
    const isScanning = ref(false);
    const isCanCelled = ref(false);
    const folderName = ref(null);
    const items = ref([]);
    const files = ref(null);
    const blacklistExt = ref([]);
    const systemDirsByOS = ref({});
    const currentFileName = ref("");
    const scanStatus = ref("wait"); // fileStart, fileEnd, fileCancelled, processing, inspectCompleted , inspectCancelled
    const showBox = ref(true);
    const totalFileCount = ref(0); // 전체 파일 수
    const totalFiles = ref(0); // 전체 파일 수
    const index = ref(0);
    const filteredPaths = ref([]);
    let hashWorker = null;
    let precheckWorker = null;
    const CHUNK = 1000;
    const os = ref("null");
    const allFiles = ref([]); // 전체 파일
    const targetFiles = ref([]); // 최종 검사할 파일 객체들
    const pathData = ref([]); // precheckWorker에 보낼 배열
    const blockedDirs = ref([]); // 차단된 디렉토리
    const targetDBName = "scanner_target_file";
    const storeName = "files";
    const resultStoreName = "results";
    const scanningFileName = ref(null);
    const scanTime = ref("00:00:00"); // 검사시간
    const scanTimer = ref(null);
    let intervalId = null;
    const inspectStartDate = ref(null);

    //methods 정의
    const getList = async (type) => {
      searchInfo.value = dc.trimObject(searchInfo.value);
      const axiosSearchInfo = tb.getSearchInfo(
        type,
        searchInfo,
        savedSearchInfo
      );

      pagingInfo.type = type;
      if (type !== 2) {
        pagingInfo.total = -1;
        paging
          .total("/scanner/pr/result/count/get", axiosSearchInfo)
          .then((res) => {
            pagingInfo.total = res;
          });
      }

      paging
        .getPageItems(
          "/scanner/pr/result/list/get",
          axiosSearchInfo,
          pagingInfo
        )
        .then((res) => {
          items.value = res;
          pagingInfo.doubleTab = true;
        });

      // 검색 조건 저장
      tb.saveSearchInfo(type, searchInfo, savedSearchInfo);
    };

    const getPage = (page) => {
      // 페이징 클릭 시 목록 조회
      pagingInfo.currentPage = page;
      pagingInfo.pageNum = page - pagingInfo.currentPage; // 클릭한 페이지 기준 차이
      pagingInfo.doubleTab = false;
      getList(2);
    };

    const goToDetail = (item) => {
      // 검색 조건을 sessionStorage에 저장
      tb.saveStateForDetail("securityScan", searchInfo.value, pagingInfo);
      // 상세 페이지로 이동
      router.push({
        name: "securityScanDetail",
        query: {
          id: item.id,
        },
      });
    };
    const convertDateFormat = (date) => {
      if (!date) return "-";
      return dt.dateTimeFormat(date?.$date);
    };
    const convertStatus = (data) => {
      switch (data.status) {
        case "Complete":
          return "완료";
        case "Error":
          return `오류(${data.description})`;
        case "Wait":
          return "대기";
        case "Processing":
          return "진행중";
        case "Cancel":
          return `취소(${data.description})`;
        default:
          return "-";
      }
    };
    // 검사 시작 시 호출
    const startScanTimer = () => {
      const startTime = Date.now();
      scanTime.value = "00:00:00";

      // 2. 이미 타이머가 실행 중이라면 중복 방지를 위해 초기화
      if (scanTimer.value) {
        clearInterval(scanTimer.value);
      }

      // 3. 타이머 시작
      scanTimer.value = setInterval(() => {
        const t = Math.floor((Date.now() - startTime) / 1000);
        scanTime.value = [
          Math.floor(t / 3600),
          Math.floor((t % 3600) / 60),
          t % 60,
        ]
          .map((v) => String(v).padStart(2, "0"))
          .join(":");
      }, 1000);
    };

    // 검사 종료 시 호출
    const stopScanTimer = () => {
      if (scanTimer.value) {
        clearInterval(scanTimer.value);
        scanTimer.value = null;
      }
    };

    // 점검 취소
    const cancelScan = () => {
      if (!isScanning.value) return;
      isCanCelled.value = true;
      isScanning.value = false;
      scanStatus.value = "inspectCancelled";

      alert(
        "점검이 취소되었습니다. 잠시만 기다려 주세요. 현재까지 점검한 내역이 저장됩니다"
      );
      stopScanTimer();

      // 워커에 점검 취소 전달
      if (scanStatus.value === "fileStart" && precheckWorker) {
        precheckWorker.postMessage({ type: "CANCEL_PRECHECK" });
        return;
      }
      if (
        scanStatus.value !== "wait" &&
        scanStatus.value !== "fileStart" &&
        hashWorker
      ) {
        hashWorker.postMessage({ type: "CANCEL_SCAN" });
        return;
      }
    };

    const getLatestVpmdVersion = async () => {
      await axios
        .get("/scanner/pr/vpmd/version/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            vpmdVer.value = res.data.resMsg;
          } else {
            alert("VPMD 버전 조회 실패");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
    const convertId = (index) => {
      // total.value 쉼표를 제거하고 숫자로 변환
      const totalCount = parseInt(
        String(pagingInfo.total).replace(/,/g, ""),
        10
      );
      if (isNaN(totalCount) || totalCount <= 0) {
        return 0;
      }
      const offset = (pagingInfo.currentPage - 1) * pagingInfo.perPage;

      if (pagingInfo.currentPage > 1) {
        return totalCount - offset - index;
      }
      return totalCount - index;
    };
    const getScannerSetting = async () => {
      await axios
        .get("/scanner/pr/setting/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            blacklistExt.value = res.data.resList.blacklistExtName || [];
            systemDirsByOS.value = res.data.resList.systemDirsByOS || {};
          }
        })
        .catch((error) => {
          console.error(error);
        });
      blockedDirs.value = systemDirsByOS.value[os.value];
    };

    // 검사 시작 버튼 버전 보내고 해시 받아옴
    const getVpmdHashes = async () => {
      await axios
        .get("/scanner/pr/vpmd/vuln/get", {
          params: { version: vpmdVer.value },
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const decoded = atob(res.data.data.hashes);
            const parsed = JSON.parse(decoded);

            vulnHashes.value = parsed;
          } else {
            alert("VPMD 해시 조회 실패");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    //드래그 앤 드롭 핸들러
    const handleDrop = async (e) => {
      console.log("handleDrop start");

      if (isScanning.value || scanStatus.value !== "wait") {
        return;
      }
      inspectStartDate.value = new Date();
      console.log("inspectStartDate.value");
      console.log(inspectStartDate.value);

      startScanTimer();

      scanStatus.value = "folderUploaded";
      isScanning.value = true;
      progress.value = 3;

      if (hashWorker) {
        hashWorker.terminate();
        hashWorker = null;
      }
      if (precheckWorker) {
        precheckWorker.terminate();
        precheckWorker = null;
      }
      await initFileScan();

      const items = e.dataTransfer.items;
      if (!items || !items.length) return;

      const entry = items[0].webkitGetAsEntry();
      if (entry && entry.isDirectory) {
        folderName.value = entry.name;
      } else {
        return;
      }
      isScanning.value = true;
      scanStatus.value = "fileStart";
      progress.value = 2;
      await new Promise((resolve) => setTimeout(resolve, 200));

      // 2. 그 다음 비동기 작업들을 수행합니다.
      await makeDB();

      // 3. 초기화 및 UI 변경
      showBox.value = true;
      scanStatus.value = "fileStart";

      console.log("3. traverseDirectory 시작");
      await traverseDirectory(entry);

      console.log("4. 드롭으로 수집된 파일 수:", allFiles.value.length);

      fileCheckProcess();
    };

    const traverseDirectory = async (rootEntry) => {
      const stack = [rootEntry]; // 탐색할 폴더들을 담는 스택
      let fileCount = 0;

      while (stack.length > 0) {
        const currentEntry = stack.pop(); // 가장 최근에 담긴 폴더 하나를 꺼냄

        try {
          console.log("현재 탐색 중:", currentEntry.fullPath);

          const reader = currentEntry.createReader();

          // 1. 현재 폴더의 모든 엔트리(파일/폴더) 읽기
          const entries = await new Promise((resolve, reject) => {
            let allEntries = [];
            const readEntries = () => {
              reader.readEntries(
                (results) => {
                  if (results.length === 0) {
                    resolve(allEntries);
                  } else {
                    allEntries.push(...results);
                    readEntries();
                  }
                },
                (err) => {
                  console.warn("권한 부족으로 건너뜀:", currentEntry.fullPath);
                  resolve([]); // 에러 시 빈 배열 반환하여 중단 방지
                }
              );
            };
            readEntries();
          });

          // 2. 읽어온 엔트리 처리
          for (const entry of entries) {
            // 필터링: 점(.)으로 시작하는 파일/폴더 제외
            if (entry.name.startsWith(".")) continue;

            scanningFileName.value = entry.name;

            if (entry.isFile) {
              // 파일 처리
              await new Promise((res) => {
                entry.file(
                  (file) => {
                    allFiles.value.push({
                      file: file,
                      path: entry.fullPath.replace(/^\//, ""),
                    });
                    fileCount++;

                    if (fileCount % 500 === 0) {
                      progress.value = Math.min(10, fileCount * 0.001);
                    }
                    res();
                  },
                  () => res()
                );
              });
            } else if (entry.isDirectory) {
              stack.push(entry);
            }
          }

          await new Promise((resolve) => setTimeout(resolve, 0));
        } catch (error) {
          console.error("폴더 처리 중 예상치 못한 오류:", error);
        }
      }

      console.log("스캔 완료! 총 파일 수:", fileCount);
      scanningFileName.value = "파일 필터링 중...";
    };
    const fileCheckProcess = () => {
      progress.value = 10;
      const fileList = allFiles.value;
      initPrecheckWorker();
      pathData.value = fileList.map((f, idx) => ({
        path: f.path,
        index: idx,
      }));

      totalFileCount.value = pathData.value.length;

      index.value = 0;
      filteredPaths.value.length = 0;

      const firstItem = allFiles.value[0];
      folderName.value = firstItem?.path?.split("/")[0] || "";
      sendNextChunk(pathData.value);
    };

    //해시 테스트 버튼
    const test = async () => {
      console.log("해시 테스트 시작");
      if (!files.value || files.value.length === 0) {
        alert("검사할 폴더를 등록하여 주십시오");
        return;
      }
      const fileSnapshot = Array.from(files.value);
      for (let i = 0; i < fileSnapshot.length; i++) {
        const file = fileSnapshot[i];
        try {
          const startTime = performance.now(); // 파일 시작 시간
          const fileSizeBytes = file.size;
          const fileSizeMB = (fileSizeBytes / (1024 * 1024)).toFixed(2);
          console.log(
            `파일 해시 계산 시작: ${file.name}, 크기: ${fileSizeMB} MB`
          );
          const hash = await calculateHashWithWorker(file);
          const endTime = performance.now(); // 파일 종료 시간
          const duration = endTime - startTime;
          console.log(`해시: ${hash} 걸린 시간: ${duration.toFixed(2)} ms`);
        } catch (error) {
          console.error("해시 계산 실패:", error);
        }
      }
      // 해시 생성 워커 종료
      hashWorker.terminate();
      hashWorker = null;
      console.log("해시 테스트 종료");
    };

    const confirmNextStep = () => {
      // 강제로 렌더링 후 실행
      // 브라우저에게 화면을 그릴 기회를 줌
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (
            !confirm(
              "폴더 스캐닝이 완료 되었습니다.\n내 PC 취약점 검사를 진행하시겠습니까?"
            )
          ) {
            restartScan();
            stopScanTimer();
            return;
          }
          handleUploadAndCompare();
        });
      });
    };

    const handleUploadAndCompare = async () => {
      console.log("handleUploadAndCompare 시작");

      scanStatus.value = "processing";
      scanningFileName.value = "";

      let status = "Complete";
      let description = null;

      try {
        // 1. 취약점 데이터 준비 및 워커 초기화
        await getVpmdHashes();
        console.log("getVpmdHashes 완료");
        initHashWorker();

        const rawHashes = toRaw(vulnHashes.value?.vulFileHashes);
        const vulnListSafe = Array.isArray(rawHashes)
          ? JSON.parse(JSON.stringify(rawHashes))
          : [];

        if (vulnListSafe.length === 0) {
          throw new Error("취약점 해시 목록을 불러오지 못했습니다.");
        }

        // 2. 워커 실행 및 완료 대기
        await new Promise((resolve, reject) => {
          // 워커 메시지 핸들러
          hashWorker.onmessage = (e) => {
            const { type, current, error, currentName } = e.data;

            if (type === "CANCELLED") {
              status = "Cancel";
              description = "사용자 취소";
              resolve();
              return;
            }
            if (type === "PROGRESS") {
              processedCount.value = current;
              currentFileName.value = currentName;
              // 0~90% 구간을 진행률로 표시
              progress.value =
                20 + Math.floor((current / targetFiles.value.length) * 70);
            }

            if (type === "COMPLETED") {
              resolve();
            }

            if (type === "ERROR") {
              reject(error);
            }
          };

          // 워커에 시작 명령
          hashWorker.postMessage({
            type: "START_SCAN",
            targetDBName,
            storeName,
            resultStoreName,
            vulnList: vulnListSafe,
          });
        });

        // 3. 결과 가공 단계
        scanStatus.value = "makeResult";
        progress.value = 95;

        // DB에서 워커가 저장한 '취약한 항목'들만 가져오기
        console.log("검출된 취약 항목을 DB에서 가져오는 중...");
        const rawResults = await getAllResultsFromDB(resultStoreName);
        console.log("검출된 취약 항목 개수:", rawResults.length);

        console.log("결과 생성중...");
        const grouped = rawResults.reduce((acc, curr) => {
          if (!acc[curr.kve]) {
            acc[curr.kve] = { kve: curr.kve, detectedHashes: [] };
          }
          acc[curr.kve].detectedHashes.push({
            filePath: curr.filePath,
            fileName: curr.fileName,
            fileSize: curr.fileSize,
            fileHash: curr.fileHash,
            description: "",
          });
          return acc;
        }, {});

        const inspectionResults = Object.values(grouped);

        console.log("inspectStartDate.value");
        console.log(inspectStartDate.value);
        // 4. 최종 결과 생성 및 저장
        const result = createResult(
          inspectStartDate.value,
          inspectionResults,
          status,
          description
        );

        scanStatus.value = "saveInspection";
        await addResult(result);
      } catch (error) {
        console.error("점검 중 오류:", error);
        status = error === "Cancelled" ? "Cancel" : "Error";
        description =
          error === "Cancelled" ? "사용자 취소" : "점검 중 오류 발생";
      } finally {
        scanStatus.value = "completed";
        progress.value = 100;
        isScanning.value = false;
        stopScanTimer();
        if (hashWorker) hashWorker.terminate(); // 워커 종료하여 자원 회수
      }
    };

    // DB에서 결과 가져오기
    const getAllResultsFromDB = (storeName) => {
      console.log("getAllResultsFromDB 실행");
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(targetDBName, 3);
        request.onsuccess = (e) => {
          const db = e.target.result;
          const transaction = db.transaction(storeName, "readonly");
          const store = transaction.objectStore(storeName);
          const getAllReq = store.getAll();
          getAllReq.onsuccess = () => resolve(getAllReq.result);
          getAllReq.onerror = () => reject(getAllReq.error);
        };
      });
    };

    const initHashWorker = () => {
      if (!hashWorker) {
        console.log("initHashWorker 워커 생성");
        hashWorker = new Worker(
          new URL("@/component/worker/fileHashWorker.js", import.meta.url),
          { type: "module" }
        );
      }
    };
    const initPrecheckWorker = () => {
      if (!precheckWorker) {
        console.log("워커 생성");
        precheckWorker = new Worker(
          new URL("@/component/worker/filePrecheckWorker.js", import.meta.url),
          { type: "module" }
        );

        precheckWorker.onmessage = handlePrecheckWorkerMessage;
      }
    };

    const makeDB = () => {
      console.log("makeDB 실행: IndexedDB 초기화");
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(targetDBName, 3);

        request.onupgradeneeded = (e) => {
          const db = e.target.result;
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName, {
              keyPath: "id",
              autoIncrement: true,
            });
          }
          if (!db.objectStoreNames.contains(resultStoreName)) {
            db.createObjectStore(resultStoreName, {
              keyPath: "id",
              autoIncrement: true,
            });
          }
        };

        request.onsuccess = (e) => {
          const db = e.target.result;
          if (!db.objectStoreNames.contains(storeName)) {
            console.error(
              "db store 생성에 실패했습니다. 삭제 후 재시도가 필요합니다."
            );
            db.close();
            return reject();
          }

          const transaction = db.transaction(
            [storeName, resultStoreName],
            "readwrite"
          );
          transaction.objectStore(storeName).clear();
          transaction.objectStore(resultStoreName).clear();

          transaction.oncomplete = () => {
            db.close();
            setTimeout(resolve, 100);
          };
        };

        request.onerror = (e) => reject(e.target.error);
      });
    };
    const saveCancelEmptyResult = async () => {
      console.log(
        "saveCancelEmptyResult 실행: 취소된 스캔에 대한 빈 결과 저장"
      );
      const result = createResult(
        inspectStartDate.value,
        [],
        "Cancel",
        "사용자 취소"
      );
      addResult(result);
    };

    const handlePrecheckWorkerMessage = async (e) => {
      console.log("handlePrecheckWorkerMessage 실행");
      const { status, filtered } = e.data;

      if (status === "cancelled") {
        console.log("[Main] 워커로부터 취소 확인 수신");
        saveCancelEmptyResult();
        return;
      }

      if (isCanCelled.value) {
        console.log("[Main] 취소 상태이므로 워커 메시지를 무시합니다.");
        saveCancelEmptyResult();
        if (precheckWorker) {
          precheckWorker.terminate();
          precheckWorker = null;
        }
        return;
      }

      if (status === "success") {
        if (scanStatus.value === "fileEnd") {
          console.log("scanStatus.value === 'fileEnd'");
          return;
        }

        if (filtered && filtered.length > 0) {
          // Proxy 이슈 방지를 위해 순수 객체로 매핑
          const itemsToStore = filtered.map((item) => {
            const original = allFiles.value[item.index];
            return {
              path: original.path,
              index: original.index,
              file: original.file, // File 객체는 그대로 전달 가능
            };
          });

          try {
            // await을 통해 순차적 저장을 보장합니다.
            await saveToIndexedDB(itemsToStore);
            filteredPaths.value.push(...itemsToStore);
          } catch (err) {
            // 에러 로그 유지
            console.error("저장 중 에러 발생:", err);
            // 에러가 나더라도 루프가 끊기지 않도록 여기서 throw 하지 않습니다.
          }
        }

        if (isCanCelled.value) {
          console.log("[Main] 취소 상태이므로 다음 조각 전송을 건너뜁니다.");
          saveCancelEmptyResult();
          if (precheckWorker) {
            precheckWorker.terminate();
            precheckWorker = null;
          }
          return;
        }
        // 진행률 업데이트 로직 유지
        const precheckProgress =
          Math.min(index.value, totalFileCount.value) / totalFileCount.value;
        progress.value = 10 + Math.floor(precheckProgress * 10);

        // 종료시점 확인 로그 및 로직 유지
        if (index.value >= totalFileCount.value) {
          console.log("모든 조각 처리 완료");
          scanStatus.value = "fileEnd";
          progress.value = 20;

          // 요청하신 데이터 할당 로직
          totalFiles.value = filteredPaths.value.length;
          targetFiles.value = [...filteredPaths.value]; // 주석 해제하여 다음 단계 전달 보장

          console.log(
            "필터링 및 DB 저장 완료. 대상:",
            targetFiles.value.length
          );

          if (precheckWorker) {
            precheckWorker.terminate();
            precheckWorker = null;
          }
          confirmNextStep();
        } else {
          // 아직 끝이 아니라면 다음 청크 실행
          sendNextChunk();
        }
      }
    };
    // 코드 원복으로 인한 주석 limcs
    // const saveToIndexedDB = async (fileObjects) => {
    //   totalFiles.value = fileObjects.length;
    //   console.log("saveToIndexedDB 실행, 객체 수:", fileObjects.length);

    //   if (isCanCelled.value) {
    //     console.log("[Main] 취소 상태이므로 IndexedDB 저장을 건너뜁니다.");
    //     return;
    //   }

    //   const request = indexedDB.open(targetDBName, 3);

    //   request.onerror = (err) => {
    //     console.error("DB 오픈 실패:", err);
    //   };

    //   return new Promise((resolve) => {
    //     request.onsuccess = async (event) => {
    //       const db = event.target.result;
    //       const batchSize = 100; // 트랜잭션당 레코드 수

    //       try {
    //         for (let i = 0; i < fileObjects.length; i += batchSize) {
    //           const batch = fileObjects.slice(i, i + batchSize);

    //           await new Promise((resolve, reject) => {
    //             const tx = db.transaction(storeName, "readwrite");
    //             const store = tx.objectStore(storeName);

    //             batch.forEach((obj) =>
    //               store.put({
    //                 path: obj.path,
    //                 index: obj.index,
    //                 file: obj.file,
    //               })
    //             );

    //             tx.oncomplete = resolve;
    //             tx.onerror = (err) => {
    //               console.error("트랜잭션 오류:", err);
    //               resolve(); // 오류 있어도 넘어가도록 처리
    //             };
    //           });

    //           // UI 차단 방지
    //           await new Promise((r) => setTimeout(r, 0));
    //         }

    //         console.log("IndexedDB에 저장 완료");
    //         db.close();
    //         resolve();
    //       } catch (e) {
    //         clearTimeout(timeout);
    //         console.error("트랜잭션 생성 실패:", e);
    //         db.close();
    //         resolve();
    //       }
    //     };
    //     request.onerror = (err) => {
    //       clearTimeout(timeout);
    //       console.error("DB 오픈 실패:", err);
    //       resolve();
    //     };
    //   });
    // };
    const saveToIndexedDB = (fileObjects) => {
      totalFiles.value = fileObjects.length;
      console.log("saveToIndexedDB 실행, 객체 수:", fileObjects.length);

      if (isCanCelled.value) {
        console.log("[Main] 취소 상태이므로 IndexedDB 저장을 건너뜁니다.");
      }

      return new Promise((resolve) => {
        const timeout = setTimeout(() => {
          console.warn("IndexedDB 응답 지연 임시로 타임아웃처리");
          resolve();
        }, 10000);

        const request = indexedDB.open(targetDBName, 3);

        request.onsuccess = (event) => {
          const db = event.target.result;

          try {
            const transaction = db.transaction(storeName, "readwrite");
            const store = transaction.objectStore(storeName);

            fileObjects.forEach((obj) => {
              store.put({
                path: obj.path,
                index: obj.index,
                file: obj.file,
              });
            });

            transaction.oncomplete = () => {
              clearTimeout(timeout);
              console.log("IndexedDB에 저장 완료");
              db.close();
              resolve();
            };

            transaction.onerror = (err) => {
              clearTimeout(timeout);
              console.error("IndexedDB 저장 중 오류 발생:", err);
              db.close();
              resolve();
            };
          } catch (e) {
            clearTimeout(timeout);
            console.error("트랜잭션 생성 실패:", e);
            db.close();
            resolve();
          }
        };

        request.onerror = (err) => {
          clearTimeout(timeout);
          console.error("DB 오픈 실패:", err);
          resolve();
        };
      });
    };

    const sendNextChunk = () => {
      console.log("sendNextChunk 실행, 현재 인덱스:", index.value);
      if (index.value >= totalFileCount.value) return;

      const nextRange = Math.min(index.value + CHUNK, totalFileCount.value);

      // File 객체를 제외
      const lightChunk = allFiles.value
        .slice(index.value, nextRange)
        .map((item, i) => ({
          path: item.path,
          index: index.value + i,
        }));

      console.log(
        `[${index.value} ~ ${nextRange}] 조각 전송:`,
        lightChunk.length
      );

      precheckWorker.postMessage({
        type: "START_PRECHECK",
        slice: lightChunk,
        blacklistExt: [...blacklistExt.value],
      });

      index.value = nextRange;
    };

    const restartScan = () => {
      scanStatus.value = "wait";
      currentFileName.value = null;
      scanningFileName.value = null;
      showBox.value = false;
      scanStatus.value = "wait";
      isCanCelled.value = false;
      isScanning.value = false;
      initFileScan();
      stopScanTimer();
    };

    const initFileScan = async () => {
      console.log("initFileScan 실행");
      allFiles.value = [];
      filteredPaths.value = [];
      index.value = 0;
      totalFileCount.value = 0;
      processedCount.value = 0;
      folderName.value = null;
    };

    const callApi = async () => {
      try {
        await axios.get("/scanner/pr/vpmd/call");
      } catch (e) {
        console.error(e);
      }
    };

    // 결과 생성
    const addResult = async (result) => {
      console.log("점검 결과 저장 시작");
      console.log("점검결과");
      console.log(result);

      await axios
        .post("/scanner/pr/result/add", result)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            isScanning.value = false;
            getList(1);
          } else {
            alert("점검 결과 저장에 실패하였습니다.");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    // 결과 생성
    const createResult = (
      inspectStartDate,
      inspectionResults,
      status,
      description
    ) => {
      console.log("createResult 실행");
      console.log("inspectionResults:", inspectionResults);
      console.log("status:", status);
      console.log("description:", description);
      console.log("totalFiles.length:", totalFiles.length);
      console.log("vulnHashes.value.version");
      console.log(vulnHashes.value.version);
      const result = {
        status,
        description,
        ip: "",
        os: os.value,
        vpmdVersion: vpmdVer.value,
        totalCount: totalFiles.value,
        inspectionResults,
        inspectStartDate,
        inspectEndDate: new Date(),
      };
      return result;
    };

    // 사용자 OS정보 조회
    const getUserOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/windows phone/i.test(userAgent)) return "Windows Phone";
      if (/windows/i.test(userAgent)) return "Windows";
      if (/android/i.test(userAgent)) return "Android";
      if (/iPad|iPhone|iPod/.test(userAgent)) return "iOS";
      if (/mac/i.test(userAgent)) return "Mac OS";
      if (/linux/i.test(userAgent)) return "Linux";

      return "Unknown OS";
    };
    //프로그래스 스탭 완료 여부 확인
    const getStepStatus = (stepName) => {
      const status = scanStatus.value;

      if (stepName === "folder") {
        const completedStates = [
          "scanning",
          "fileStart",
          "fileEnd",
          "processing",
          "inspectCompleted",
          "makeResult",
          "completed",
          "inspectCancelled",
          "saveInspection",
        ];
        if (status === "folderUploaded") return "is-active";
        if (completedStates.includes(status)) {
          return "is-done";
        }

        return "is-wait";
      }

      if (stepName === "scanning") {
        if (status === "fileStart") return "is-active";
        if (status === "fileCancelled") return "is-wait"; // 실패 상태 처리 가능
        const completedStates = [
          "fileEnd",
          "processing",
          "inspectCompleted",
          "makeResult",
          "completed",
          "inspectCancelled",
          "saveInspection",
        ];
        if (completedStates.includes(status)) return "is-done";
        return "is-wait";
      }

      if (stepName === "checking") {
        if (status === "processing") return "is-active";
        if (status === "inspectCancelled") return "is-wait";
        const completedStates = [
          "inspectCompleted",
          "makeResult",
          "saveInspection",
          "completed",
        ];
        if (completedStates.includes(status)) return "is-done";
        return "is-wait";
      }

      if (stepName === "saving") {
        if (status === "makeResult" || status === "saveInspection")
          return "is-active";
        if (status === "completed") return "is-done";
        return "is-wait";
      }

      return "is-wait";
    };

    // computed 정의
    const isLoading = computed(() => store.state.loading.isLoading);
    const processedCount = ref(0);
    // const totalFiles = computed(() => {
    //   return targetFiles.value.length;
    // });

    //router 정의
    onBeforeRouteLeave((to, from, next) => {
      console.log("onBeforeRouteLeave 실행");
      console.log("isScanning.value:", isScanning.value);

      // 점검 중이 아니면 바로 이동 허용
      if (!isScanning.value) {
        return next();
      }

      if (confirm("뒤로 가면 점검 내용이 사라집니다. 이동하시겠습니까?")) {
        next();
      } else {
        next(false);
      }
    });
    const handleKeyDown = (e) => {
      if (e.key === "F5") {
        console.log("F5 키 감지됨");

        // 스캔 중일 때만 새로고침 방지
        if (isScanning.value) {
          e.preventDefault();
          return;
        }
      }
    };
    const handleBeforeUnload = (e) => {
      if (!isScanning.value) return;
      console.log("새로고침/닫기 시도 감지");
      e.preventDefault();
      return;
    };
    // life cycle 정의
    onMounted(() => {
      getScannerSetting();
      getLatestVpmdVersion();
      initFileScan();

      os.value = getUserOS();
      const retrievedState = tb.retrieveAndClearState(
        "securityScan",
        "securityScanDetail",
        searchInfo,
        savedSearchInfo,
        pagingInfo
      );
      const {
        type: type,
        searchInfo: parsedSearchInfo,
        pagingInfo: parsedPagingInfo,
      } = retrievedState;
      getList(type);

      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("keydown", handleKeyDown);
      intervalId = setInterval(() => {
        if (isScanning.value) {
          callApi();
        }
      }, 5 * 60 * 1000);
    });

    onUnmounted(() => {
      console.log("onUnmounted 실행");
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      stopScanTimer();
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    });

    // html에서 사용될 데이터 정의
    return {
      items,
      scanningFileName,
      pagingInfo,
      goToDetail,
      folderName,
      getPage,
      progress,
      cancelScan,
      convertDateFormat,
      convertStatus,
      isLoading,
      convertId,
      currentFileName,
      scanStatus,
      showBox,
      test,
      handleDrop,
      getStepStatus,
      restartScan,
      scanTime,
    };
  },
};
</script>